import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { racesDataSource } from 'infrastructure/data-sources/races';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IRaceItem } from 'infrastructure/data-sources/races';

type Options = IBaseSelectBoxOption<IRaceItem['id'], IRaceItem>[];

interface IRaceSelectBoxProps extends Omit<IBaseSelectBoxProps, 'options'> {}

const RaceSelectBox: React.FC<IRaceSelectBoxProps> = (props) => {
  const dataSource = useMemo(() => racesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default RaceSelectBox;
